<template>
  <div
    id="chr-roadmap"
    class="tw-flex tw-flex-col tw-items-starttw-self-stretch tw-bg-[#ffffff]"
  >
    <div class="!tw-break-inside-avoid">
      <div class="tw-flex tw-justify-between tw-w-[100%] tw-pb-[12px]">
        <div
          class="tw-text-[#211F58] tw-text-[24px] tw-font-semibold tw-flex-1"
        >
          <span
            id="chr-sheading-roadmap"
            class="tw-w-fit tw-flex tw-items-center tw-justify-center"
          >
            {{ getComponentUiText("app-share-cyber-profile-roadmap-title-1") }}
          </span>
        </div>
        <div
          v-if="customTableData?.length > 0 && isEdit"
          class="tw-h-[44px] tw-mr-[20px] tw-relative tw-flex tw-items-center tw-flex-wrap"
        >
          <TextInputWithArrow
            :max="maxPaging"
            :paging="paging || maxPaging || 5"
            :type="localStorageKey.sharingPagingRoadmap"
            :custom-input-class="'tw-text-[14px]'"
            @arrow-click="handleArrowClick"
          />
        </div>
        <div
          v-if="isEnableEdit"
          id="pen-icon-traffic"
          :class="isEdit ? 'tw-bg-[#211F58]' : 'tw-bg-[#FFF]'"
          class="header__pen tw-cursor-pointer"
          @click="editNotes"
        >
          <Pen :color="isEdit ? '#ffffff' : '#387DFF'" />
        </div>
      </div>
      <div
        class="tw-text-[#231F20] tw-text-[14px] tw-font-normal lg:tw-w-[50%] tw-pb-[40px] tw-opacity-[0.7]"
      >
        {{ getComponentUiText("app-rshare-cyber-profile-roadmap-sub-title-1") }}
      </div>
    </div>
    <RoadmapTable
      :data="customTableData"
      :is-loading="isLoading"
      :is-edit-status="isEdit"
      @edit-notes="editNotes"
    />
  </div>
</template>

<script lang="ts" setup>
import { getComponentUiText } from "@/utils/utilities";
import { Ref, computed, ref, watch } from "vue";
import RoadmapTable from "./roadmapTable.vue";
import store from "@/store";
import Pen from "../svgs/pen.vue";
import { Checklist } from "@/services/apiRoutes/routes";
import TextInputWithArrow from "@/components/share/textInputWithArrow.vue";
import { localStorageKey } from "@/utils/constants";

const props = defineProps({
  isEdit: {
    type: Boolean,
    default: false,
  },
  isEnableEdit: {
    type: Boolean,
    default: true,
  },
  rootChecklistReportId: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(["update:edit"]);

const paging: Ref<number> = ref(5);
const maxPaging = computed(() => {
  const data = store.getters["Sharing/getChecklistRoadMap"];
  return data && data.length ? data.length : 0;
});

const handleArrowClick = ({ value }) => {
  paging.value = value;

  if (!props.rootChecklistReportId || props.rootChecklistReportId === 0) return;

  const localData = JSON.parse(
    localStorage.getItem(localStorageKey.sharingPagingRoadmap) || "{}",
  );

  localData[props.rootChecklistReportId] = value;

  localStorage.setItem(
    localStorageKey.sharingPagingRoadmap,
    JSON.stringify(localData),
  );
};

const getPagingValue = () => {
  const localData = JSON.parse(
    localStorage.getItem(localStorageKey.sharingPagingRoadmap) || "{}",
  );

  if (!props.rootChecklistReportId || props.rootChecklistReportId === 0)
    return maxPaging.value;

  if (localData[props.rootChecklistReportId]) {
    const value = Number(localData[props.rootChecklistReportId]);
    return value > maxPaging.value ? maxPaging.value : value;
  }

  return maxPaging.value;
};

watch(
  () => maxPaging.value,
  (newVal) => {
    maxPaging.value && (paging.value = getPagingValue());
  },
);

const customTableData = computed(() => {
  const data = store.getters["Sharing/getChecklistRoadMap"];
  if (!paging.value || typeof paging.value !== "number") return [];
  return !paging.value ? data : data.slice(0, Number(paging.value) || 5);
});

const isLoading: Ref<any> = computed(() => {
  return store.state.Sharing.loadingSplit[
    Checklist.getChecklistReportDataActions
  ];
});

const editNotes = () => {
  emit("update:edit", !props.isEdit);
};
</script>

<style lang="scss" scoped>
.header__pen {
  border-radius: 6px;
  border: 1px solid var(--UI-rule, #eff0f1);
  padding: 9px 14px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  width: 46px;
  height: 44px;
}

.is_editable {
  background: var(--Brand-Navy, #211f58);
}

.not_editable {
  background: var(--UI-white, #fff);
}

@media print {
  :deep(.table-header) {
    background-color: #211f58 !important;
    &:first-of-type {
      padding-left: 25px !important;
    }
  }
  #pen-icon-traffic {
    display: none;
  }
}
</style>
